const HTTP_URL_REGEX = /^https?:\/\//i;

const isHttpUrl = (value?: string): boolean =>
  typeof value === 'string' && HTTP_URL_REGEX.test(value.trim());

/**
 * Çerez Politikası PDF'inin medya sunucusu (web) linkini döndürür.
 *
 * CMS'te URL asıl olarak `belbim_cookie_cerezPolitikasiLink` altında tutulur;
 * bazı CMS kitaplarında doğrudan `belbim_cookie_cerezPolitikasi` altında da
 * gelebildiği için ikisi de değerlendirilir. `belbim_cookie_cerezPolitikasi`
 * çoğunlukla yalnızca "Çerez Politikası" etiket metnini taşıdığından, sadece
 * geçerli bir http(s) adresi bulunursa döndürülür; aksi halde undefined.
 */
const getCookiePolicyUrl = (link?: string, fallback?: string): string | undefined => {
  if (isHttpUrl(link)) return (link as string).trim();
  if (isHttpUrl(fallback)) return (fallback as string).trim();
  return undefined;
};

export default getCookiePolicyUrl;
